<template>
  <div class="step-basic-editor">
    <el-form :model="localStep" :size="size" label-width="140px">
      <el-form-item label="步骤ID">
        <el-input v-model="localStep.stepId" disabled></el-input>
      </el-form-item>
      <el-form-item label="步骤名称">
        <el-input
          v-model="localStep.stepName"
          placeholder="请输入步骤名称"
          @input="updateField('stepName', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否动作步骤">
        <el-switch
          :value="localStep.actionStep"
          @change="updateField('actionStep', $event)"
          active-text="是"
          inactive-text="否"
        ></el-switch>
        <div style="color: #909399; font-size: 12px; margin-top: 4px">
          只有动作步骤才能设置动作列表
        </div>
      </el-form-item>
      <el-form-item v-if="!isActionStep" label="问题模板">
        <el-input
          v-model="localStep.questionTemplate"
          type="textarea"
          :rows="3"
          placeholder="请输入问题模板，可使用变量如 ${TIME}"
          @input="updateField('questionTemplate', $event)"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item v-if="!isActionStep" label="问题状态">
        <el-select
          :value="localStep.problemStatus"
          @change="updateField('problemStatus', $event)"
          placeholder="请选择问题状态"
          style="width: 100%"
        >
          <el-option
            v-for="option in problemStatusOptions"
            :key="option.value"
            :label="option.label || option.value"
            :value="option.value"
          ></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item v-if="!isActionStep" label="当前回复角色">
        <el-select
          :value="localStep.replyAsRole"
          @change="updateField('replyAsRole', $event)"
          placeholder="请选择当前回复角色"
          style="width: 100%"
        >
          <el-option
            v-for="option in msgRoleOptions"
            :key="option.value"
            :label="option.label || option.value"
            :value="option.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!isActionStep" label="下一步处理角色">
        <el-select
          :value="localStep.nextHandleRole"
          @change="updateField('nextHandleRole', $event)"
          placeholder="请选择下一步处理角色"
          style="width: 100%"
        >
          <el-option
            v-for="option in msgRoleOptions"
            :key="option.value"
            :label="option.label || option.value"
            :value="option.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="nextRoleIsDriver" label="是否允许上传文件">
        <el-switch
          :value="localStep.allowUpload"
          @change="updateField('allowUpload', $event)"
          active-text="是"
          inactive-text="否"
        ></el-switch>
      </el-form-item>

      <el-form-item v-if="!isActionStep" label="默认下一步ID">
        <el-select
          :value="localStep.defaultNextStepId"
          @change="updateField('defaultNextStepId', $event)"
          filterable
          placeholder="请选择默认下一步"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="step in stepOptions"
            :key="step.stepId"
            :label="step.label"
            :value="step.stepId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="!isActionStep" label="允许的任务类型">
        <el-select
          :value="localStep.allowedTaskTypes"
          @change="updateField('allowedTaskTypes', $event)"
          multiple
          placeholder="请选择允许的任务类型"
          style="width: 100%"
        >
          <el-option
            v-for="option in taskTypeOptions"
            :key="option.value"
            :label="option.label || option.value"
            :value="option.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "StepBasicEditor",
  props: {
    stepId: {
      type: String,
      required: true
    }
  },
  inject: {
    getEditingStepData: {
      from: "getEditingStepData",
      default: () => () => null
    },
    updateEditingStepField: {
      from: "updateEditingStepField",
      default: () => () => {}
    }
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize
    }),
    ...mapGetters("problemFlowConfig", [
      "steps",
      "stepIds",
      "stepOptions",
      "problemStatusOptions",
      "taskTypeOptions",
      "msgRoleOptions"
    ]),
    localStep() {
      // 优先使用临时编辑状态，否则使用 store 中的数据
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        return editingStepData;
      }
      return this.steps[this.stepId] || {};
    },
    allStepIds() {
      return this.stepIds;
    },
    isActionStep() {
      return this.localStep.actionStep === true;
    },
    nextRoleIsDriver() {
      return this.localStep.nextHandleRole === "DRIVER";
    }
  },
  methods: {
    updateField(field, value) {
      // 空字符串转为null
      const _value = value && value.trim && value.trim() === "" ? null : value;

      // 优先更新临时编辑状态，否则直接更新 store
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        this.updateEditingStepField(field, _value);

        // 如果设置为动作步骤，清空不需要的字段
        if (field === "actionStep" && _value === true) {
          this.updateEditingStepField("questionTemplate", null);
          this.updateEditingStepField("problemStatus", null);
          this.updateEditingStepField("allowedTaskTypes", null);
          this.updateEditingStepField("dealResult", null);
          this.updateEditingStepField("defaultNextStepId", null);
        }
      } else {
        this.$store.dispatch("problemFlowConfig/updateStepField", {
          stepId: this.stepId,
          field,
          value: _value
        });

        // 如果设置为动作步骤，清空不需要的字段
        if (field === "actionStep" && _value === true) {
          const fieldsToClear = [
            "questionTemplate",
            "problemStatus",
            "allowedTaskTypes",
            "dealResult",
            "defaultNextStepId"
          ];
          fieldsToClear.forEach((f) => {
            this.$store.dispatch("problemFlowConfig/updateStepField", {
              stepId: this.stepId,
              field: f,
              value: null
            });
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.step-basic-editor {
  padding: 10px;
}
</style>
